import makeRequestSaga from './requests';

export default makeRequestSaga;
